import * as React from 'react';

const SvgArrowUpRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="#56565b"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="arrow-up-right_svg__feather arrow-up-right_svg__feather-arrow-up-right"
    {...props}
  >
    <path d="M7 17L17 7M7 7h10v10" />
  </svg>
);

export default SvgArrowUpRight;
